var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormularioFigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 263,
    viewBox: "0 0 319 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.256 187.3C364.831 370.9 89.4685 370.9 89.4685 187.3C89.4685 370.9 -185.894 370.9 -2.31889 187.3C-185.894 370.9 -185.894 95.5 -2.31889 95.5C-185.894 95.5 -185.894 -179.9 -2.31889 3.69998C-185.894 -179.9 89.4685 -179.9 89.4685 3.69998C89.4685 -179.9 364.831 -179.9 181.256 3.69998C364.831 -179.9 364.831 95.5 181.256 95.5C364.915 95.5 364.915 370.9 181.256 187.3Z",
    fill: "url(#paint0_radial_2446_2266)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2446_2266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0402 96.1629) scale(255.402 255.437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormularioFigure);
export default __webpack_public_path__ + "static/media/formulario_figure.e2be2bb459dfaccaee06a847ed033094.svg";
export { ForwardRef as ReactComponent };